import { TimePicker as AntTimePicker, TimePickerProps } from 'antd'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledTimePicker = styled(AntTimePicker)<{ $preventInput?: boolean }>`
  :focus {
    border: none;
    border-bottom: 1px solid var(--color-primary-109);
    border-radius: 0;
    box-shadow: none;
  }
  height: 36px;
  border: none;
  border-bottom: 1px solid var(--color-gray-103);
  border-radius: 0;
  padding: 8px 0;
  &.ant-picker-focused {
    border-bottom: 1px solid var(--color-primary-109) !important;
    box-shadow: none !important;
  }
  .ant-picker-clear {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ $preventInput }) =>
      $preventInput ? `caret-color: transparent; cursor: not-allowed;` : ``}
  }
  input {
    ${({ $preventInput }) =>
      $preventInput ? `caret-color: transparent; cursor: not-allowed;` : ``}
  }
`
const StyledTitleMain = styled.div`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
  span {
    color: var(--color-red-107);
  }
`
interface IProps extends TimePickerProps {
  title?: string | ReactNode
  required?: boolean
  preventInput?: boolean
}

const TimePicker = (props: IProps) => {
  const { t } = useTranslation()
  const { title, required, preventInput, allowClear, ...resProps } = props
  return (
    <>
      <StyledTitleMain>
        {typeof title === 'string' ? t(title) : title}
        {required && <span>*</span>}
      </StyledTitleMain>
      <StyledTimePicker
        $preventInput={preventInput}
        open={preventInput ? false : undefined}
        allowClear={preventInput ? false : allowClear}
        suffixIcon={<img src="images/ic-clock.svg" alt="" />}
        format="HH:mm"
        {...resProps}
      />
    </>
  )
}

export default TimePicker
